import React, { useState } from "react";
import { AlertTriangle, Trash2, X } from "lucide-react";
import { practiceApi } from "../../lib/practiceApi";
import "./bulk.css";

export const BulkDeleteBar = ({ collection, ids, onDeleted, onClear, testId = "bulk" }) => {
  const [preview, setPreview] = useState(null);
  const [confirm, setConfirm] = useState("");
  const [quoteNames, setQuoteNames] = useState({});
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (!ids.length) return null;

  async function open() {
    setBusy(true); setError(""); setConfirm(""); setQuoteNames({});
    try { setPreview(await practiceApi("/bulk/preview", { method: "POST", body: JSON.stringify({ collection, ids }) })); }
    catch (err) { setError(err.message); } finally { setBusy(false); }
  }

  async function run() {
    setBusy(true); setError("");
    try {
      const result = await practiceApi("/bulk/delete", { method: "POST", body: JSON.stringify({ collection, ids, confirm, quote_confirmations: quoteNames }) });
      setPreview(null); setConfirm("");
      onClear();
      onDeleted(result);
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  }

  const locked = (preview?.requires_confirmation && confirm.trim().toUpperCase() !== "ELIMINA") || (preview?.quote_confirmations || []).some(q => (quoteNames[q.id] || "").trim() !== q.name);

  return <>
    <div className="bulk-bar" data-testid={`${testId}-bar`}>
      <strong data-testid={`${testId}-count`}>{ids.length} selezionati</strong>
      <button className="bulk-clear" data-testid={`${testId}-clear`} onClick={onClear}>Annulla selezione</button>
      <button className="bulk-delete" disabled={busy} data-testid={`${testId}-delete`} onClick={open}><Trash2 size={15} />{busy ? "Verifica…" : "Elimina selezionati"}</button>
    </div>
    {error && !preview && <div className="error" role="alert" data-testid={`${testId}-error`}>{error}</div>}

    {preview && <div className="modal-backdrop">
      <div className="create-modal bulk-modal" data-testid={`${testId}-modal`}>
        <button type="button" className="modal-close" data-testid={`${testId}-modal-close`} onClick={() => setPreview(null)}><X /></button>
        <p className="eyebrow">ELIMINAZIONE DEFINITIVA</p>
        <h2>{preview.selected.length} {preview.label}</h2>

        <ul className="bulk-list" data-testid={`${testId}-selected`}>
          {preview.selected.slice(0, 12).map(row => <li key={row.id}>{row.label}</li>)}
          {preview.selected.length > 12 && <li className="muted">e altri {preview.selected.length - 12}…</li>}
        </ul>

        {preview.impact.length > 0 && <div className="bulk-impact" data-testid={`${testId}-impact`}>
          <strong><AlertTriangle size={14} />Verranno eliminati anche:</strong>
          <ul>{preview.impact.map(row => <li key={row.key} data-testid={`${testId}-impact-${row.key}`}>{row.count} {row.label}</li>)}</ul>
        </div>}

        {preview.blocked.length > 0 && <div className="practice-notice" data-testid={`${testId}-blocked`}>
          {preview.blocked.length} elementi verranno saltati: {preview.blocked.slice(0, 5).map(b => `${b.label} (${b.reason})`).join(", ")}
        </div>}

        {preview.requires_confirmation && <label className="bulk-confirm">Sono coinvolti {preview.documents} documenti archiviati: digita ELIMINA per confermare
          <input data-testid={`${testId}-confirm-input`} value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="ELIMINA" autoFocus />
        </label>}

        {error && <div className="error" role="alert" data-testid={`${testId}-modal-error`}>{error}</div>}
        {(preview.quote_confirmations || []).map(q => <label className="bulk-confirm" key={q.id}>Preventivo n° {q.number}: digita <strong data-testid={`${testId}-quote-name-${q.id}`}>{q.name}</strong><input data-testid={`${testId}-quote-confirm-${q.id}`} autoComplete="off" value={quoteNames[q.id] || ""} onChange={e => setQuoteNames({ ...quoteNames, [q.id]: e.target.value })} /></label>)}

        <div className="bulk-actions">
          <button className="ghost" data-testid={`${testId}-cancel`} onClick={() => setPreview(null)}>Annulla</button>
          <button className="bulk-delete" disabled={busy || locked || !preview.selected.length} data-testid={`${testId}-confirm`} onClick={run}><Trash2 size={15} />{busy ? "Eliminazione…" : "Elimina definitivamente"}</button>
        </div>
      </div>
    </div>}
  </>;
};
